import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import EstaSegGral from '../../../components/funcionales/estaseggral';

// "use strict";

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//dropdown CLASES
const DetalleNivelClase = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const ListaClase = ({styles, handleLista4, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelClase styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4} onClick={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES
//dropdown ESTADOS
const DetalleNivel1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento.estadoCli}>{props.elemento.estadoCli}</option>
  )
};

const Lista = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoCli" id="miLista6" value={argsDocum.estadoCli} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ESTADOS
//dropdown DATOS CONFIRMADOS
const DetalleNivelDC = props => {
  return (
    <option style={props.styles.input} value={props.elemento.datosConfirmados}>{props.elemento.datosConfirmados}</option>
  )
};

const ListaDC = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivelDC styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="datosConfirmados" id="miLista7" value={argsDocum.datosConfirmados} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown DATOS CONFIRMADOS

//Lista de OS
const DetCli = ({elemento, opciones1, empresaArchFE}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.descrRecursoR}</td>
      <td className=''>{elemento.codigoCiudad}</td>
      <td className=''>{elemento.nombreBarrio}</td>
      <td className=''>{elemento.direccionCli}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.telefonos}</td>
      {/* <td className=''>{elemento.direccionCli.substr(0, 40)}</td>
      <td className=''>{elemento.nombreCliente.substr(0, 15)}</td>
      <td className=''>{elemento.apellidoCliente.substr(0, 15)}</td>
      <td className=''>{elemento.telefonos.substr(0, 15)}</td> */}
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.codigoTipoDoc}</td>
      <td className=''>{elemento.numeroDoc}</td>
      <td className=''>{elemento.eMail}</td>
      <td className=''>{elemento.estadoCliente.substr(0, 2)}</td>
      <td className=''>{elemento.cargoMensual}</td>
      <td className=''>{elemento.saldoPendiente}</td>
    </tr>
  )
};

const ListaCli = ({list, opciones1, empresaArchFE}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetCli elemento={elemento} key={i} opciones1={opciones1} empresaArchFE={empresaArchFE}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let argsBuscarMC = {tipoqry: `[{$match: {tipo: 'X'}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
// let argsBuscarCLR = {tipoqry: `[{$match: {contrato: 'XXYYZZ'}},{$lookup: {from: 'movclientes', localField: 'contrato', foreignField: 'contrato', as: 'movimientos'}}]`}

class ProcEC2 extends React.Component {
  state={argsDocum: {_id: "",
        estadoCli: "Todos...", datosConfirmados: "Todos...", descrClaseServ: "Todas...",
        cicloFact: "Todos...",
        descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...", nombreBarrio: "Todos..."},
        opciones: "opcion1", opciones1: "opcion4", argsSelDpto: this.props.argsSelDpto, listRtes: [],
        totCli: 0, confirmaAct: false, open: false, errors: [], renderizar: true,
        verEnPantalla: false}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target.checked)
    const argsDocum = this.state.argsDocum
    let listRtes = []
    this.setState({listRtes, totCli: 0})
    this.setState({verEnPantalla: false})

    if(ev.target.name==="opciones"||ev.target.name==="opciones1"){
      if(ev.target.checked===true){
        if(ev.target.name==="opciones"){
          this.setState({opciones: ev.target.value})
        }else{
          this.setState({opciones1: ev.target.value})
        }
      }
    }else{  
      argsDocum[ev.target.name] = ev.target.value
    }

    this.setState({argsDocum});
    // console.log(argsDocum)
  }

  handleSubmit = async (ev, argsDocum, opciones, opciones1)=>{
    // console.log(ev.target.name)
    let targetName = ev.target.name
    // console.log(argsDocum)
    document.body.style.cursor = 'wait'

    if(targetName==="pantalla"){
      this.setState({verEnPantalla: true})
    }
    if(targetName==="pantalla"&&this.state.listRtes.length===0){
      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let argsUpd
      let errors = []
      if(!this.props.allClientesRtes.allClientesRtes){
        // console.log("no ha cargado allClientesRtes")
        errors.push({path: "Enviar correo", message: "Proceso de cargue de la información, por favor espere un momento..."});
      }
      // console.log(this.state.argsDocum)
      this.setState({errors})
      if(errors.length===0){
        this.setState({renderizar: false})
        //Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
        // let clientesFra = []
        let argsBuscarCLR=""
        argsBuscarCLR += `'eMail': {$nin: [null, ""]}, `
        if(opciones1==="opcion4"){
          argsBuscarCLR += `'envFraCorreo': 'N'`
        }else{
          argsBuscarCLR += `'envFraCorreo': 'S'`
        }
        if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!==""){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'estadoCliente': '${this.state.argsDocum.estadoCli}'`
        }
        if(this.state.argsDocum.datosConfirmados!=="Todos..."&&this.state.argsDocum.datosConfirmados!==""){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'datosConfirmados': '${this.state.argsDocum.datosConfirmados}'`
        }
        if(this.state.argsDocum.cicloFact!=="Todos..."&&this.state.argsDocum.cicloFact!==""){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'cicloFact': '${this.state.argsDocum.cicloFact}'`
        }

        // console.log(this.state.argsSelDpto.descrClaseServ)
        if(this.state.argsSelDpto.descrClaseServ!==undefined&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'tarifa.servicios.subclaseserv.claseserv.descrClaseServ': '${this.state.argsSelDpto.descrClaseServ}'`
        }

        if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

        }else{
          if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
            if(argsBuscarCLR){argsBuscarCLR += `, `}
            argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}'`
          }else{
            if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
              if(argsBuscarCLR){argsBuscarCLR += `, `}
              argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                  'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
            }else{
              if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                if(argsBuscarCLR){argsBuscarCLR += `, `}
                argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              }else{
                if(argsBuscarCLR){argsBuscarCLR += `, `}
                argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'nombreZona': '${this.state.argsSelDpto.nombreZona}', 
                    'nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
              }
            }
          }
        }

        // console.log(this.state.argsSelDpto)

        let clientesLis = []
        argsBuscarCLR = `${argsBuscarCLR}`
        argsBuscarCLR = '{' + argsBuscarCLR + '}'
        // console.log(argsBuscarCLR)
        argsBuscarCLR = {tipoqry: `[
          {$project: {contrato: 1, estadoCliente: 1, envFraCorreo: 1, dirmayor: 1, direccion: 1,
            nombreCliente: 1, apellidoCliente: 1, datosConfirmados: 1,
            telefono1: 1, telefono2: 1, telefono3: 1,eMail: 1, cargoMensual: 1, saldoPendiente: 1,
            descrDpto: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.descrDpto", else: "" } },
            nombreCiudad: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.ciudades.nombreCiudad", else: "" } },
            nombreZona: {$cond: { if: { $ifNull: [ "$dirmayor.ciudades.zonas", false ] }, then: "$dirmayor.ciudades.zonas.nombreZona", else: "" } },
            nombreBarrio: {$cond: { if: { $ifNull: [ "$dirmayor.ciudades.zonas", false ] }, then: "$dirmayor.ciudades.zonas.barrios.nombreBarrio", else: "" } },
            referencia1: "$tipodoc.codigoTipoDoc", numeroDoc: 1,
            tarifa: {$cond: { if: { $ifNull: [ "$tarifa", false ] }, then: "$tarifa", else: {servicios: [{subclaseserv: {claseserv: {descrClaseServ: ""}}}]} } },
            cicloFact: {$cond: { if: { $ifNull: [ "$cicloFact", false ] }, then: "$cicloFact", else: "" } },
          }},
          {$match: ${argsBuscarCLR}},
          {$sort: {nombreCliente: 1, apellidoCliente: 1, referencia1: 1, estadoCliente: 1, cicloFact: 1, descrEstrato: 1}},
        ]`}
        // console.log(argsBuscarCLR)
        // console.time(1)
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCLR)
        clientesLis = await data.allClientesRtes

        argsBuscarCLR = {tipoqry: `[
          {$match: {contrato: '123XYZ'}},
        ]`}
        await this.props.allClientesRtes.refetch(argsBuscarCLR)


        // console.log(clientesLis)
        // console.log(this.state.argsDocum)
        let listRtes = []
        let totCli = 0
        // console.time(3)
        clientesLis.forEach(async (elemento1, i) => {
          // for(let i=0; i<clientesLis.length; i++){
          //   let elemento1 = clientesLis[i]

          let direccionCli = ""
          if(elemento1.direccion&&elemento1.direccion.descrTipoVia1){
            direccionCli = elemento1.direccion.descrTipoVia1?elemento1.direccion.descrTipoVia1:""
            direccionCli += elemento1.direccion.numeroTipoVia1?" " + elemento1.direccion.numeroTipoVia1:""
            direccionCli += elemento1.direccion.descrTipoVia2?" " + elemento1.direccion.descrTipoVia2:""
            direccionCli += elemento1.direccion.numeroTipoVia2?" " + elemento1.direccion.numeroTipoVia2:""
            direccionCli += elemento1.direccion.numeroTipoVia2F?" " + elemento1.direccion.numeroTipoVia2F:""
            direccionCli += elemento1.direccion.descrTipoUnd1?" " + elemento1.direccion.descrTipoUnd1:""
            direccionCli += elemento1.direccion.numeroTipoUnd1?" " + elemento1.direccion.numeroTipoUnd1:""
            direccionCli += elemento1.direccion.descrTipoUnd2?" " + elemento1.direccion.descrTipoUnd2:""
            direccionCli += elemento1.direccion.numeroTipoUnd2?" " + elemento1.direccion.numeroTipoUnd2:""
          }
          let telefonos = ""
          if(elemento1.telefono1){telefonos = elemento1.telefono1}
          if(elemento1.telefono2){telefonos?telefonos += "-" + elemento1.telefono2:telefonos = elemento1.telefono2}
          if(elemento1.telefono3){telefonos?telefonos += "-" + elemento1.telefono3:telefonos = elemento1.telefono3}

          argsUpd = {}

          argsUpd = {
            "descrRecursoR": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.descrRecursoR:"",
            "codigoCiudad": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.codigoCiudad:"",
            "nombreBarrio": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
            "direccionCli": direccionCli,
            "nombreCliente": elemento1.nombreCliente,
            "apellidoCliente": elemento1.apellidoCliente,
            "telefonos": telefonos,
            "contrato": elemento1.contrato,
            "codigoTipoDoc": elemento1.referencia1,
            "numeroDoc": elemento1.numeroDoc,
            "eMail": elemento1.eMail,
            "estadoCliente": elemento1.estadoCliente,
            "cargoMensual": elemento1.cargoMensual,
            "saldoPendiente": elemento1.saldoPendiente,
          }
          listRtes.push(argsUpd)
          totCli += 1
        })
        // console.timeEnd(3)

        // console.log(listRtes)
        // console.time(4)
        if(opciones==="opcion1"){
          listRtes = _.orderBy(listRtes, ['descrRecursoR', 'codigoCiudad', 'nombreBarrio', 'direccionCli'], ['asc', 'asc', 'asc', 'asc'])
        }
        if(opciones==="opcion2"){
          listRtes = _.orderBy(listRtes, ['nombreCliente', 'apellidoCliente'], ['asc', 'asc'])
        }
        if(opciones==="opcion3"){
          listRtes = _.orderBy(listRtes, ['contrato'], ['asc'])
        }
        this.setState({renderizar: true})
        this.setState({listRtes})
        this.setState({totCli})
        // console.timeEnd(4)
        clientesLis = []
        listRtes = []
      }
    }
    if(targetName==="form1"){
      // console.log(this.state.listRtes.length, this.state.listRtes)
      let errors = []
      if(this.state.listRtes.length===0){
        errors.push({path: "Enviar correo", message: "NO hay clientes seleccionados"});
      }
      this.setState({errors})
      if(errors.length===0){
        let envFraCorreo = "S"
        if(opciones1==="opcion5"){
          envFraCorreo = "N"
        }
        for(let i=0; i<this.state.listRtes.length; i++){
          // console.log(this.state.listRtes.length, i, this.state.listRtes[i].contrato)
          // let editDatosBas = []
          let argsUpd = {}
          argsUpd = {
            "accionBD": this.props.editCliente,
            "tipoAct": "EditarCliEnvFraCorreo",
            "contrato": this.state.listRtes[i].contrato,
            "envFraCorreo": envFraCorreo,
          }
          // editDatosBas.push(argsUpd)
          await this.props.editCliente({
            variables: argsUpd
          });
        }
        let listRtes = []
        this.setState({listRtes, totCli: 0})
        this.setState({verEnPantalla: false})  
      }
    }
    if(targetName==="excel"){
      let xlsString = []
      let listRtes = this.state.listRtes
      // console.log(listRtes)
      let xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Doc', '# Doc', 'Correo', 'Est', '$ mes', 'Saldo']
      xlsString.push(xlsString1)

      for(let i=0; i<listRtes.length; i++){
        let fechaCreacionSistema = "", fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", valorUltPago = 0
        if(listRtes[i].fechaCreacionSistema){
          fechaCreacionSistema = new Date(listRtes[i].fechaCreacionSistema)
          fechaCreacionSistema = (fechaCreacionSistema.getUTCFullYear()) + '-' + ((fechaCreacionSistema.getUTCMonth()+1)<10?'0'+(fechaCreacionSistema.getUTCMonth()+1):(fechaCreacionSistema.getUTCMonth()+1)) + '-' + (fechaCreacionSistema.getUTCDate()<10?'0'+fechaCreacionSistema.getUTCDate():fechaCreacionSistema.getUTCDate())
          fechaCreacionSistema = new Date(fechaCreacionSistema+'T23:00:00.000Z')
        }
        if(listRtes[i].fechaPrimeraActivacion){
          fechaPrimeraActivacion = new Date(listRtes[i].fechaPrimeraActivacion)
          fechaPrimeraActivacion = (fechaPrimeraActivacion.getUTCFullYear()) + '-' + ((fechaPrimeraActivacion.getUTCMonth()+1)<10?'0'+(fechaPrimeraActivacion.getUTCMonth()+1):(fechaPrimeraActivacion.getUTCMonth()+1)) + '-' + (fechaPrimeraActivacion.getUTCDate()<10?'0'+fechaPrimeraActivacion.getUTCDate():fechaPrimeraActivacion.getUTCDate())
          fechaPrimeraActivacion = new Date(fechaPrimeraActivacion+'T23:00:00.000Z')
        }
        if(listRtes[i].fechaUltDX){
          fechaUltDX = new Date(listRtes[i].fechaUltDX)
          fechaUltDX = (fechaUltDX.getUTCFullYear()) + '-' + ((fechaUltDX.getUTCMonth()+1)<10?'0'+(fechaUltDX.getUTCMonth()+1):(fechaUltDX.getUTCMonth()+1)) + '-' + (fechaUltDX.getUTCDate()<10?'0'+fechaUltDX.getUTCDate():fechaUltDX.getUTCDate())
          fechaUltDX = new Date(fechaUltDX+'T23:00:00.000Z')

        }
        if(listRtes[i].fechaUltPago){
          fechaUltPago = new Date(listRtes[i].fechaUltPago)
          fechaUltPago = (fechaUltPago.getUTCFullYear()) + '-' + ((fechaUltPago.getUTCMonth()+1)<10?'0'+(fechaUltPago.getUTCMonth()+1):(fechaUltPago.getUTCMonth()+1)) + '-' + (fechaUltPago.getUTCDate()<10?'0'+fechaUltPago.getUTCDate():fechaUltPago.getUTCDate())
          fechaUltPago = new Date(fechaUltPago+'T23:00:00.000Z')
        }
        if(listRtes[i].valorUltPago){
          valorUltPago = listRtes[i].valorUltPago
        }

        xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad, listRtes[i].nombreBarrio, listRtes[i].direccionCli,
                      listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
                      listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc, listRtes[i].eMail,
                      listRtes[i].estadoCliente,listRtes[i].cargoMensual,
                      listRtes[i].saldoPendiente]
        xlsString.push(xlsString1)
      }
      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };
      
      wb.SheetNames.push("Clientes");
      
      let ws_data = xlsString;
      
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Clientes"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'clientes.xlsx');
  //FIN Exportar a XLS
    }

    document.body.style.cursor = 'default'

    // console.log("listooooo")
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
    if(btnPress==="btnUpdDel"){
      this.setState({confirmaAct: false})
    };
  }

  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        (this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona)||
        (this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio)){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio

      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      this.setState({listRtes: [], totCli: 0})
      this.setState({verEnPantalla: false})
    }
  }

  shouldComponentUpdate(){
    if(this.state.renderizar){
      return true
    }else{
      return false
    }
  }

  componentWillUnmount(){
    let listRtes = []
    this.setState({listRtes})
    this.setState({verEnPantalla: false})
  }

  render(){
    const {argsDocum, opciones, opciones1, listRtes, totCli,
            confirmaAct, errors, verEnPantalla, open} = this.state;
    const a102201 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102201" );
    const a102205 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102205" );

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let conSinAut = "AUTORIZAR ENVIO"
    if(opciones1==="opcion5"){
      conSinAut = "NO AUTORIZAR ENVIO"
    }
    // console.log(open)
    // console.log(this.props.empresa.empresaArchFE)
            // console.log(listOSCl)

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Para enviar correo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1):()=>{}}>
              <div>
              <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '15%'}}>
                      <h1 style={{color: '#2C7744'}}>Para enviar correo</h1>
                    </div>
                    <div className="column" style={{width: '40%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Sin autorización&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Con autorización</label>
                      </fieldset>
                    </div>
                    <div className="column" style={{width: '40%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Ordenar por&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Tercero + Barrio + Dir&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Nombre&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Contrato</label>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Estado
                      </p>
                      <Form.Field>
                        <Lista styles={this.props.styles} list={this.props.list2} argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Datos confirmados
                      </p>
                      <Form.Field>
                        <ListaDC styles={this.props.styles} list={this.props.list7} argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciclo de facturación
                      </p>
                      <Form.Field>
                        <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Clase
                      </p>
                      <Form.Field>
                        <ListaClase styles={this.props.styles} list={this.props.list3} handleLista4={this.props.handleLista4}  argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista}
                          codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2}
                          argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3}
                          argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total Clientes: {totCli}
                </p>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '33%'}}>
                      <Button name="pantalla" id="pantalla" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} primary fluid>
                        <i className='large drivers license yellow icon'></i>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    {a102201!==-1 &&
                      <div className="column" style={{width: '33%'}}>
                        <Button name="excel" id="excel" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} primary fluid>
                          <i className='large file excel yellow icon'></i>
                          ARCHIVO EXCEL
                        </Button>
                      </div>
                    }
                    {a102205!==-1 &&
                      <div className="column" style={{width: '33%'}}>
                        <EstaSegGral btnText={conSinAut} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Tercero</th>
                        <th className=''>Ciudad</th>
                        <th className=''>Barrio</th>
                        <th className=''>Dirección</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''>Teléfonos</th>
                        <th className=''>Contr</th>
                        <th className=''>Doc</th>
                        <th className=''># Doc</th>
                        <th className=''>Correo</th>
                        <th className=''>Est</th>
                        <th className=''>$ mes</th>
                        <th className=''>Saldo</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaCli list={listRtes} opciones1={opciones1}/>
                    }
                  </table>
                </div>  
              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),
)(ProcEC2)
